/** U11 (lote 2): tipo da caixa de e-mail (atendimento, corporativa ou pessoal), dono e delegações, nos três idiomas. */
const pt = {
  u11l2: {
    acesso: 'Acesso',
    acessoTitulo: 'Acesso às caixas de e-mail',
    acessoTexto:
      'Atendimento: lida pelas filas. Corporativa: quem vê todas as conversas e as pessoas delegadas. Pessoal: só o dono e quem ele delegar; nem o Administrador vê sem a delegação, e ela fica fora de filas, métricas, automações e da IA. Por padrão, a pessoal e a corporativa deixam de fora Promoções, Social e Atualizações. Toda delegação e toda leitura de caixa alheia vão para a auditoria.',
    tipo: 'Tipo',
    tipo_atendimento: 'Atendimento',
    tipo_corporativa: 'Corporativa',
    tipo_pessoal: 'Pessoal',
    dono: 'Dono',
    avisoPessoal: 'Depois de salvar, só o dono lê a caixa e só ele muda o tipo, o dono ou as delegações.',
    categorias: 'Promoções, Social e Atualizações do Gmail',
    categoriasPadrao: 'Padrão do tipo',
    categoriasIgnorar: 'Deixar de fora',
    categoriasTrazer: 'Trazer também',
    soDono: 'Só o dono muda a caixa pessoal.',
    delegados: 'Pessoas delegadas',
    semDelegadosPessoal: 'Ninguém além do dono.',
    semDelegadosCorporativa: 'Só quem vê todas as conversas.',
    delegarA: 'Delegar a',
    delegar: 'Delegar',
    retirarCurto: 'Retirar',
    retirar: 'Retirar a delegação de {{nome}}',
    delegada: 'Delegação feita',
    retirada: 'Delegação retirada',
    acessoSalvo: 'Acesso salvo',
    porDelegacao: 'Você lê esta caixa por delegação.',
    abrirMao: 'Abrir mão',
    seloPessoal: 'pessoal de {{nome}}',
    seloCorporativa: 'corporativa',
    semNome: 'sem nome',
  },
};

type Dic = typeof pt;

const en: Dic = {
  u11l2: {
    acesso: 'Access',
    acessoTitulo: 'Access to the mailboxes',
    acessoTexto:
      'Support: read through the queues. Department: whoever sees all conversations and the delegated people. Personal: only the owner and whoever they delegate; not even the Administrator sees it without delegation, and it stays out of queues, metrics, automations and AI. By default, personal and department mailboxes leave out Promotions, Social and Updates. Every delegation and every read of someone else’s mailbox goes to the audit log.',
    tipo: 'Type',
    tipo_atendimento: 'Support',
    tipo_corporativa: 'Department',
    tipo_pessoal: 'Personal',
    dono: 'Owner',
    avisoPessoal: 'After saving, only the owner reads the mailbox and only they change its type, owner or delegations.',
    categorias: 'Gmail Promotions, Social and Updates',
    categoriasPadrao: 'Type default',
    categoriasIgnorar: 'Leave out',
    categoriasTrazer: 'Bring them too',
    soDono: 'Only the owner changes a personal mailbox.',
    delegados: 'Delegated people',
    semDelegadosPessoal: 'Nobody besides the owner.',
    semDelegadosCorporativa: 'Only whoever sees all conversations.',
    delegarA: 'Delegate to',
    delegar: 'Delegate',
    retirarCurto: 'Remove',
    retirar: 'Remove the delegation of {{nome}}',
    delegada: 'Delegation granted',
    retirada: 'Delegation removed',
    acessoSalvo: 'Access saved',
    porDelegacao: 'You read this mailbox by delegation.',
    abrirMao: 'Give up',
    seloPessoal: '{{nome}}’s personal',
    seloCorporativa: 'department',
    semNome: 'no name',
  },
};

const es: Dic = {
  u11l2: {
    acesso: 'Acceso',
    acessoTitulo: 'Acceso a los buzones de correo',
    acessoTexto:
      'Atención: se lee por las colas. Corporativo: quien ve todas las conversaciones y las personas delegadas. Personal: solo el dueño y quien él delegue; ni el Administrador lo ve sin la delegación, y queda fuera de colas, métricas, automatizaciones y de la IA. Por defecto, el personal y el corporativo dejan fuera Promociones, Social y Notificaciones. Toda delegación y toda lectura de un buzón ajeno van a la auditoría.',
    tipo: 'Tipo',
    tipo_atendimento: 'Atención',
    tipo_corporativa: 'Corporativo',
    tipo_pessoal: 'Personal',
    dono: 'Dueño',
    avisoPessoal: 'Después de guardar, solo el dueño lee el buzón y solo él cambia el tipo, el dueño o las delegaciones.',
    categorias: 'Promociones, Social y Notificaciones de Gmail',
    categoriasPadrao: 'Predeterminado del tipo',
    categoriasIgnorar: 'Dejar fuera',
    categoriasTrazer: 'Traer también',
    soDono: 'Solo el dueño cambia el buzón personal.',
    delegados: 'Personas delegadas',
    semDelegadosPessoal: 'Nadie además del dueño.',
    semDelegadosCorporativa: 'Solo quien ve todas las conversaciones.',
    delegarA: 'Delegar a',
    delegar: 'Delegar',
    retirarCurto: 'Retirar',
    retirar: 'Retirar la delegación de {{nome}}',
    delegada: 'Delegación hecha',
    retirada: 'Delegación retirada',
    acessoSalvo: 'Acceso guardado',
    porDelegacao: 'Lees este buzón por delegación.',
    abrirMao: 'Renunciar',
    seloPessoal: 'personal de {{nome}}',
    seloCorporativa: 'corporativo',
    semNome: 'sin nombre',
  },
};

export const u11l2 = { pt, en, es };
